import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  blobsToOrganizationsForSelectedOrganization: [],
  getBlobsToOrganizationsForSelectedOrganizationStatus: IDLE,

  createBlobsToOrganizationsForSelectedOrganizationStatus: IDLE,
  deleteBlobsToOrganizationsStatus: IDLE
};

const blobsToOrganizationsSlice = createSlice({
  name: 'blobsToOrganizations',
  initialState,
  reducers: {
    createBlobsToOrganizationsForSelectedOrganization: (state) => {
      state.createBlobsToOrganizationsForSelectedOrganizationStatus = LOADING;
    },
    createBlobsToOrganizationsForSelectedOrganizationSucceeded: (state) => {
      state.createBlobsToOrganizationsForSelectedOrganizationStatus = SUCCEEDED;
    },
    createBlobsToOrganizationsForSelectedOrganizationFailed: (state) => {
      state.createBlobsToOrganizationsForSelectedOrganizationStatus = FAILED;
    },

    getBlobsToOrganizationsForSelectedOrganization: (state) => {
      state.getBlobsToOrganizationsForSelectedOrganizationStatus = LOADING;
    },
    getBlobsToOrganizationsForSelectedOrganizationSucceeded: (state, action) => {
      state.getBlobsToOrganizationsForSelectedOrganizationStatus = SUCCEEDED;
      state.blobsToOrganizationsForSelectedOrganization = action.payload;
    },
    getBlobsToOrganizationsForSelectedOrganizationFailed: (state) => {
      state.getBlobsToOrganizationsForSelectedOrganizationStatus = FAILED;
    },

    deleteBlobsToOrganizations: (state) => {
      state.deleteBlobsToOrganizationsStatus = LOADING;
    },
    deleteBlobsToOrganizationsSucceeded: (state) => {
      state.deleteBlobsToOrganizationsStatus = SUCCEEDED;
    },
    deleteBlobsToOrganizationsFailed: (state) => {
      state.deleteBlobsToOrganizationsStatus = FAILED;
    },

    clearBlobsToOrganizations: (state) => {
      state.blobsToOrganizationsForSelectedOrganization = [];
      state.getBlobsToOrganizationsForSelectedOrganizationStatus = IDLE;
    }
  }
});

export const {
  createBlobsToOrganizationsForSelectedOrganization,
  createBlobsToOrganizationsForSelectedOrganizationSucceeded,
  createBlobsToOrganizationsForSelectedOrganizationFailed,
  getBlobsToOrganizationsForSelectedOrganization,
  getBlobsToOrganizationsForSelectedOrganizationSucceeded,
  getBlobsToOrganizationsForSelectedOrganizationFailed,
  deleteBlobsToOrganizations,
  deleteBlobsToOrganizationsSucceeded,
  deleteBlobsToOrganizationsFailed,
  clearBlobsToOrganizations
} = blobsToOrganizationsSlice.actions;

export default blobsToOrganizationsSlice.reducer;
